import React from 'react';

import { HistoricalReportTable } from '../HistoricalReportTable';

export default class MasterUserReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
    };
  }

  componentDidUpdate() {
    if (this.props.isCsvAvailable) {
      this.setState({ reports: this.props.automaticMasterReportData });
      this.props.clearAutomaticReportProps();
    }
  }

  componentDidMount() {
    this.props.getAllMasterUserReport();
  }

  render() {
    return (
      <div className="p-3">
        <hr />
        <h2>Master User Report</h2>
        <HistoricalReportTable
          reports={this.state.reports}
          loading={this.props.allMasterUserReportLoading}
          columns={['createdAtParsed', 'link']}
        />
      </div>
    );
  }
}
